





















import {Component, Emit, Prop, Vue} from 'vue-property-decorator'

abstract class BaseBtncfg {
  text!: string
  show!: boolean
  type!: string
  style!: {}
}

export class CancelBtncfg extends BaseBtncfg {
}

export class ConfirmBtncfg extends BaseBtncfg {
}

@Component({})
export default class DialogFooter extends Vue {

  @Prop()
  protected cancelBtncfg!: CancelBtncfg | undefined

  @Prop()
  protected confirmBtncfg!: ConfirmBtncfg | undefined

  @Emit()
  cancel() {
    //
  }

  @Emit()
  confirm() {
    //
  }
}
